import { defineStore } from 'pinia';
import type { IPrizePop, IState, IUserInfo } from './interface';
import { getBookshelfInfo, schemaSupportMap } from '@q-front-npm/jsbridge';
import { useStoreCommon } from '@qm-activity/common/store/common';
import { apiShareActionReport } from '@common/http/api';
import { getNormalSiteBookDefault } from '@/assets/ts/const';
export const useStore = defineStore('store', {
    state: (): IState => {
        return {
            popManage: {
                share: false, // 分享
                shareAward: false, // 分享-奖品
                shareReview: false, // 分享-回顾
                myAward: false, // 我的奖品
                win: false, // 中奖-普通
                inviteCode: false, // 邀请口令
                taskModule: false, // 任务模块（仅被动更新数据，日历引导中使用）
                viewTrophy: false, // 查看奖杯
                getTrophy: false, // 中奖奖杯
                openTrophy: false, // 奖杯开奖动画
                popTransition: false, // 过渡动画弹窗
            },
            indexData: {
                stage: 1,
                pending_score: 0,
                currentIndex: -1,
                inviteCount: 0,
                score: 0,
                isFinish: false,
                top_banner: {},
            },
            popData: {
                winList: [],
            },
            pointData: {},
            userInfo: {},
            winClick: '',
            isCalendarGuideEnd: true, //日历引导结束
            retryStatus: {
                isRetrying: false, // 是否处于重试状态
                retryEnd: false, // 重试结束
            },
            siteBookListMap: {}, // 站点书籍列表映射
        };
    },
    actions: {
        async initSiteBookListMap() {
            if (!schemaSupportMap.get_bookshelf_book_ids) {
                const obj = getNormalSiteBookDefault();
                this.siteBookListMap = obj;
                return;
            }
            const res = await getBookshelfInfo();
            const obj = getNormalSiteBookDefault(res.split(',') || []);
            console.log('---- site book', res, obj);
            this.siteBookListMap = obj;
        },
        setPopManage(key: string, value: boolean) {
            if (key === 'all') {
                this.popManage.win = false;
                this.popManage.getTrophy = false;
                this.popManage.openTrophy = false;
                this.popManage.popTransition = false;
                return;
            }
            this.popManage[key] = value;
            if (['share', 'shareAward'].includes(key)) {
                const storeCommon = useStoreCommon();
                apiShareActionReport(storeCommon.userInfo.invite_code);
            }
        },
        setIndexData(data: Record<string, any>, isReset = false) {
            if (isReset) {
                this.indexData = {
                    ...data,
                    showCurrentPosition: this.indexData.showCurrentPosition,
                };
                return;
            }
            this.indexData = {
                ...this.indexData,
                ...data,
            };
        },
        setPopData(data: Record<string, any>) {
            this.popData = {
                ...this.popData,
                ...data,
            };
        },
        setUserInfo(data: Record<string, any>) {
            this.userInfo = data;
        },
        setWinClick(data: string) {
            this.winClick = data;
        },
        setPointData(data: Record<string, any>) {
            this.pointData = data;
        },
    },
});
